import { useQuery } from "@tanstack/react-query";

import { get } from "common/helpers/HTTP";

async function getBraintreeToken() {
  return (await get(`billing/token`)).token;
}

export default function useBraintreeToken() {
  const { data: braintreeToken, isLoading: isLoadingBraintreeToken } = useQuery(
    { queryKey: ["braintreeToken"], queryFn: getBraintreeToken },
  );

  return { braintreeToken, isLoadingBraintreeToken };
}
